import { getSubdomainFranchise } from '../utils/get-subdomain';
import { httpInterceptor } from './http.interceptor'; // ← ADICIONE ESTA IMPORTAÇÃO

class ConfiguracoesService {
  private subdomain: string;

  constructor() {
    this.subdomain = getSubdomainFranchise();
  }

  async getAllConfigs(): Promise<any> {
    
    try {
      // ← USE O INTERCEPTOR EM VEZ DO FETCH DIRETO
      const response = await httpInterceptor.get('/xparameter');
      return await response.json();
    } catch (erro) {
      throw erro;
    }
  }

  async updateParam(param: string, value: any): Promise<any> {
    try {
      // ← USE O INTERCEPTOR EM VEZ DO FETCH DIRETO
      const response = await httpInterceptor.patch('/xparameter', {
        chave: param, 
        valor: value.toString()
      });

      return await response.json();
    } catch (erro) {
      throw erro;
    }
  }
}

export const configuracoesService = new ConfiguracoesService();
